import elementTypes from 'generics/components/basic-text-editor-slate/elements/types';

export function getDisabledElements() {

  const disabledElements = [
    elementTypes.POLL_EDITOR_VIEW,
    elementTypes.SINGLE_PRODUCER_MEETING,
    elementTypes.HT_STARTUP_EVENT,
    elementTypes.HT_STARTUP_EVENT_TEMPLATE,
    elementTypes.FORM,
    elementTypes.BLOCK_QUOTE,
    elementTypes.IMAGE,
    elementTypes.SPINNER,
    elementTypes.URL_EMBED,
    elementTypes.POLL_EDITOR_VIEW,
    elementTypes.SINGLE_PRODUCER_MEETING,
    elementTypes.HT_STARTUP_EVENT_TEMPLATE,
    elementTypes.HT_STARTUP_EVENT,
    elementTypes.FORM,
    elementTypes.FORM_SUBMISSION,
    elementTypes.HTML_IMPORTER,
    elementTypes.TABLE_OF_CONTENTS,
    elementTypes.PRODUCT,
    elementTypes.AUTHENTICATOR_BUTTON,
    elementTypes.SYNCHRONIZED_PAGE_REGION,
    elementTypes.EMAIL_QUOTE,
    elementTypes.MEMBER_CALENDAR,
    elementTypes.TOGGLE_LIST_ITEM
  ];

  return disabledElements;

}

export function getEnabledElements() {

  const enabledElements = [
    elementTypes.DEFAULT,
    elementTypes.BLOCK_QUOTE,
    elementTypes.HEADING_ONE,
    elementTypes.HEADING_TWO,
    elementTypes.HEADING_THREE,
    elementTypes.HEADING_FOUR,
    elementTypes.HEADING_FIVE,
    elementTypes.HEADING_SIX,
    elementTypes.LINK,
    elementTypes.LIST_ITEM,
    elementTypes.BULLETED_LIST,
    elementTypes.NUMBERED_LIST,
    elementTypes.BULLETED_LIST_ITEM,
    elementTypes.NUMBERED_LIST_ITEM,
    elementTypes.CHECK_LIST_ITEM,
    elementTypes.URL_EMBED,
    elementTypes.DIVIDER,
    elementTypes.HT_FILE,
    elementTypes.COLUMNS,
    elementTypes.COLUMN,
    elementTypes.TABLE,
    elementTypes.TABLE_BODY,
    elementTypes.TABLE_ROW,
    elementTypes.TABLE_CELL,
    elementTypes.YOUTUBE,
    elementTypes.AI_ASSISTANT
  ];

  return enabledElements;

};